import { createTokenManager } from '@gokrew/ui/auth';
import { Portal, AUTH_REFRESH_URL } from '@gokrew/models/constants';

export const tokenManager = createTokenManager({
  namespace: Portal.Company,
  refreshUrl: AUTH_REFRESH_URL,
});
